module.exports = __webpack_public_path__ + "img/LTD-front.669caa6c.jpg";